import { createContext } from 'react';

var InstantSearchContext = createContext(null);

export { InstantSearchContext };
